var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.996 511.996",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9E6C0A"
    },
    cx: 77.609,
    cy: 259.522,
    r: 77.609
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B07E09"
    },
    d: "M414.016,413.891c-2.05,0-4.07-0.059-6.06-0.176c-16.615-0.979-26.649-5.869-36.351-10.599 c-8.568-4.175-16.659-8.119-30.174-9.671c-20.797-2.389-42.676,2.357-65.027,14.104c-4.363,2.293-9.757,0.615-12.05-3.748 c-2.293-4.363-0.615-9.757,3.748-12.05c25.584-13.446,50.941-18.84,75.366-16.037c16.551,1.9,26.86,6.924,35.957,11.358 c8.869,4.322,16.528,8.056,29.583,8.826c36.041,2.127,63.52-16.518,73.797-34.739c3.847-6.82,15.428-30.806,2.955-53.133 c-2.403-4.302-0.864-9.738,3.44-12.142c4.302-2.403,9.738-0.864,12.142,3.44c17.004,30.443,2.008,61.737-2.993,70.604 C480.991,400.7,444.572,413.89,414.016,413.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#855914"
    },
    d: "M77.608,308.033c-26.746,0-48.506-21.76-48.506-48.505c0-26.746,21.76-48.506,48.506-48.506 s48.505,21.76,48.505,48.506C126.113,286.273,104.354,308.033,77.608,308.033z M77.608,228.869 c-16.906,0-30.659,13.754-30.659,30.659c0,16.904,13.754,30.658,30.659,30.658s30.658-13.754,30.658-30.658 C108.266,242.623,94.513,228.869,77.608,228.869z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B07E09"
    },
    cx: 77.609,
    cy: 181.925,
    r: 77.609
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#855914"
    },
    d: "M77.608,230.425c-26.746,0-48.506-21.76-48.506-48.505s21.76-48.505,48.506-48.505 s48.505,21.76,48.505,48.505S104.354,230.425,77.608,230.425z M77.608,151.262c-16.906,0-30.659,13.754-30.659,30.658 s13.754,30.658,30.659,30.658s30.658-13.754,30.658-30.658S94.513,151.262,77.608,151.262z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF830C"
    },
    cx: 147.163,
    cy: 217.595,
    r: 77.609
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#855914"
    },
    d: "M147.197,266.666c-2.202,0-4.427-0.149-6.669-0.454c-12.986-1.773-24.506-8.496-32.436-18.933 c-7.93-10.436-11.32-23.335-9.547-36.322c0.667-4.883,5.173-8.3,10.048-7.635c4.883,0.666,8.301,5.165,7.635,10.048 c-1.128,8.263,1.029,16.471,6.075,23.111c5.046,6.641,12.375,10.919,20.638,12.046c17.061,2.331,32.829-9.656,35.158-26.714 c0.667-4.883,5.165-8.301,10.049-7.635c4.883,0.667,8.301,5.165,7.635,10.049C192.43,248.795,171.331,266.666,147.197,266.666z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#9E6C0A"
    },
    cx: 434.387,
    cy: 253.324,
    r: 77.609
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#855914"
    },
    d: "M434.392,301.824c-26.745,0-48.505-21.76-48.505-48.505s21.76-48.505,48.505-48.505 c26.746,0,48.506,21.76,48.506,48.505S461.138,301.824,434.392,301.824z M434.392,222.66c-16.904,0-30.658,13.754-30.658,30.658 s13.754,30.658,30.658,30.658c16.906,0,30.659-13.754,30.659-30.658S451.298,222.66,434.392,222.66z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B07E09"
    },
    cx: 434.387,
    cy: 175.715,
    r: 77.609
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#855914"
    },
    d: "M434.392,224.216c-26.745,0-48.505-21.76-48.505-48.505s21.76-48.505,48.505-48.505 c26.746,0,48.506,21.76,48.506,48.505S461.138,224.216,434.392,224.216z M434.392,145.052c-16.904,0-30.658,13.754-30.658,30.658 s13.754,30.658,30.658,30.658c16.906,0,30.659-13.754,30.659-30.658S451.298,145.052,434.392,145.052z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BF830C"
    },
    cx: 364.833,
    cy: 217.642,
    r: 77.609
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#855914"
    },
    d: "M364.837,266.715c-27.057,0-49.069-22.012-49.069-49.07s22.012-49.069,49.069-49.069 s49.069,22.012,49.069,49.069S391.893,266.715,364.837,266.715z M364.837,186.422c-17.216,0-31.222,14.006-31.222,31.222 s14.006,31.223,31.222,31.223s31.222-14.006,31.222-31.223S382.053,186.422,364.837,186.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA710C"
    },
    d: "M133.462,293.97c4.414,0.786,8.951,1.221,13.59,1.228h0.224 c42.809-0.061,77.496-34.781,77.496-77.606c0-42.862-34.746-77.608-77.608-77.608c-4.678,0-9.252,0.437-13.701,1.23 C133.462,141.215,133.462,293.97,133.462,293.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#774C13"
    },
    d: "M133.462,245.656v19.063c2.296,0.663,4.656,1.164,7.066,1.493c2.242,0.306,4.466,0.454,6.669,0.454 c24.135,0,45.232-17.87,48.586-42.436c0.666-4.883-2.752-9.381-7.635-10.049c-4.883-0.666-9.381,2.752-10.049,7.635 c-2.328,17.058-18.096,29.045-35.158,26.714C139.598,248.072,136.411,247.092,133.462,245.656z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.545,
    y: 139.986,
    style: {
      fill: "#B378DD"
    },
    width: 218.895,
    height: 155.218
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA710C"
    },
    d: "M378.538,294.023V141.268c-4.45-0.794-9.023-1.23-13.701-1.23c-8.482,0-16.637,1.38-24.276,3.894 c-1.228,39.216-20.672,73.836-50.157,95.682c9.279,31.486,37.974,54.627,72.235,55.584h4.399 C370.95,295.088,374.789,294.691,378.538,294.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#774C13"
    },
    d: "M334.245,179.321c-4.243,12.683-10.487,24.445-18.346,34.927c-0.077,1.123-0.131,2.253-0.131,3.397 c0,27.057,22.012,49.07,49.069,49.07c4.756,0,9.349-0.694,13.701-1.961v-19.06c-4.139,2.031-8.789,3.174-13.701,3.174 c-17.216,0-31.222-14.006-31.222-31.223s14.006-31.222,31.222-31.222c4.913,0,9.562,1.145,13.701,3.174v-19.06 c-4.352-1.268-8.946-1.961-13.701-1.961C353.274,168.576,342.64,172.606,334.245,179.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A69C4"
    },
    d: "M327.541,139.984L327.541,139.984c0,68.438-55.48,123.919-123.919,123.919h-57.072v31.293h218.9 V139.984H327.541z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#855914"
    },
    cx: 118.882,
    cy: 186.303,
    r: 8.923
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWool);
export default __webpack_public_path__ + "static/media/wool.9b6d0d2d829d4df6ec40072750d36d85.svg";
export { ForwardRef as ReactComponent };